import { useEffect, useState } from 'react';

export default function CustomCursor() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isPointer, setIsPointer] = useState(false);

  useEffect(() => {
    const onMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
    };

    const onMouseOver = (e) => {
      const target = e.target;
      setIsPointer(
        window.getComputedStyle(target).cursor === 'pointer' ||
        target.tagName.toLowerCase() === 'button' ||
        target.tagName.toLowerCase() === 'a'
      );
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseover', onMouseOver);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseover', onMouseOver);
    };
  }, []);

  return (
    <div
      className={`custom-cursor ${isPointer ? 'cursor-pointer' : ''}`}
      style={{
        position: 'fixed',
        pointerEvents: 'none',
        width: '20px',
        height: '20px',
        backgroundColor: 'transparent',
        border: '2px solid rgba(255, 255, 255, 0.8)',
        borderRadius: '50%',
        transform: `translate(-1%, -1%)`,
        left: `${position.x}px`,
        top: `${position.y}px`,
        transition: 'width 0.1s, height 0.1s',
        zIndex: 9999,
        mixBlendMode: 'difference'
      }}
    />
  );
}
